/**
 * Helper function to write exhaustive switch statements.
 *
 * Call this method in the default branch of a switch on an enum and pass the enum value as parameter. When you have
 * handled all enum branches the code will compile. If a branch is missing, as the missing enum branch cannot be assigned
 * to the type never.
 * @param _ The parameter for which you want to make sure all values have been handled.
 */
export function assertUnreachable(_: never): never {
    throw new Error("Didn't expect to get here");
}
